import React from "react";
import {  Image, Layout, Space, Spin } from "antd";
import secureShareLogo from './images/secure-share_logo.png'

const { Content } = Layout;



const PageLoader: React.FC = () => {
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Content className="flex flex-col space-y-6" style={{ padding: "50px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <div> <div className='flex flex-col space-y-6'>
            {' '}
            <Spin tip='' size='large'>
              <div className='content' />
            </Spin>
          </div></div>
       
        <div style={{ position: "absolute", bottom: "20px" }}>
        <div className='flex justify-center'>
            <Space>
              <Image width={150} src={secureShareLogo} preview={false} />
            </Space>
          </div>

        </div>
      </Content>
    </Layout>
  );
};

export default PageLoader;
